<template>
  <el-date-picker
    class="time-picker"
    v-model="datePicked"
    type="daterange"
    align="right"
    :unlink-panels="true"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    value-format="yyyy-MM-dd"
    :picker-options="pickerOptions"
    @change="datePickedChange"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'DatePicker',
  data() {
    return {
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate() - 1)
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8)
              end.setTime(end.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              end.setTime(end.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 91)
              end.setTime(end.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ]
    }
  },
  methods: {
    datePickedChange() {
      this.$emit('datePickedChange', this.datePicked)
    }
  }
}
</script>

<style scoped>
</style>
